import {Lang} from 'yougile-lang'
import {ObjUtil} from 'yougile-util'
import {DataObjectId, DeadlineStickerValue} from 'yougile-model'
import {DepartmentsClient} from '@client/departments-client'
import {Sync} from '@client/sync'
import {UserSettings} from '@client/user-settings'
import {MenuSimpleItemData} from '@components/common/base/menu'
import {TabData} from '@components/common/base/tabs'
import {crmStore} from '@components/crm/crm-store'
import {TaskPage} from '@components/my-tasks/my-tasks-conf'
import {TaskItem, taskItemFromHub} from '@components/my-tasks/task-item'
import {globals} from '@extensions/globals-base'
import {getAllowedMirroredOldestHub} from '@extensions/mirrored-tasks/get-allowed-mirrored-oldest-hub'
import {DeadlineCtl} from '@extensions/sticker/controllers/deadline-ctl'
import {Sticker, stickerCtl} from '@extensions/sticker/sticker'
import {Task} from '@extensions/task'

export const tabsData = (): TabData[] => [
  {
    id: 'my',
    title: Lang.msg.taskPage.myTasks,
    hint: Lang.msg.taskPage.myTasksHint,
    icon: 'IconCustomTask',
    hintPlacement: 'bottom'
  },
  {
    id: 'by-me',
    title: Lang.msg.taskPage.byMe,
    hint: Lang.msg.taskPage.byMeHint,
    icon: 'IconCustomMove',
    hintPlacement: 'bottom'
  },
  {
    id: 'private',
    title: Lang.msg.taskPage.privateList,
    hint: Lang.msg.taskPage.privateListHint,
    icon: 'IconCustomLock',
    hintPlacement: 'bottom',
    visible: true
  },
  {
    id: 'starred',
    title: Lang.msg.taskPage.starredTab,
    hint: Lang.msg.taskPage.starredHint,
    icon: 'IconCustomStar',
    hintPlacement: 'bottom'
  }
]

export const editListMenuOptions = (): MenuSimpleItemData[] => [
  {
    id: 'edit',
    icon: 'pencil',
    title: Lang.msg.myTasksRenameList
  },
  {
    id: 'delete',
    icon: 'IconCustomTrash',
    title: Lang.msg.myTasksDeleteList,
    color: 'status-error'
  }
]

export const getAllTasksFromPrivateLists = (): DataObjectId[] => {
  const tasksLists = UserSettings.getAllTasksLists()
  const tasksFromPrivateLists =
    tasksLists &&
    ObjUtil.keys(tasksLists).reduce<DataObjectId[]>((acc, taskListId) => {
      if (tasksLists[taskListId].type === 'private') {
        return [...acc, ...(tasksLists[taskListId]?.tasks || [])]
      }
      return acc
    }, [])

  return tasksFromPrivateLists || []
}

// TODO! Deprecated! remove after refactoring the whole my-tasks page!
export const getAllUsersTasks = (page: TaskPage): TaskItem[] => {
  const tasks: TaskItem[] = []
  const box = Sync.getCurrentSandbox()
  const hierarchy = DepartmentsClient.getHierarchy(box)
  const deadlineSticker = stickerCtl.Deadline.getSticker(box)
  const allTasksFromPrivateLists = getAllTasksFromPrivateLists()

  Task.forEachTask(box, hierarchy, t => {
    if (!t || Task.isArchived(t) || box.isDeleted(t.id) || crmStore.isDeal(t)) {
      return
    }

    if (Task.isTaskTemplate(t)) {
      return
    }

    const oldestMirror = getAllowedMirroredOldestHub(t)
    if (oldestMirror) {
      if (t.id !== oldestMirror) {
        return
      }
    }

    const assigned = Sticker.getUsers(t)
    if (page === 'private') {
      if (
        t.data.private !== globals.currentUserId ||
        allTasksFromPrivateLists.includes(t.id)
      ) {
        return
      }
    } else {
      if (t.data.private && page !== 'starred') {
        return
      }
      if (page === 'by-me') {
        const assignedBy = Task.getAssignedBy(t)
        if (
          !globals.currentUserId ||
          !assignedBy.includes(globals.currentUserId)
        ) {
          return
        }
      } else if (page === 'my') {
        if (
          !globals.currentUserId ||
          !assigned.includes(globals.currentUserId)
        ) {
          return
        }
      } else if (page === 'by-people') {
        if (
          assigned.length === 0 ||
          (assigned.length === 1 && assigned[0] === globals.currentUserId)
        ) {
          return
        }
      } else if (page === 'not-assigned') {
        if (assigned.length > 0) {
          return
        }
      } else if (page === 'starred') {
        const starred = UserSettings.isStarred(t)
        if (!starred) {
          return
        }
      } else if (page === 'expired') {
        const val = deadlineSticker
          ? (t.stickers[deadlineSticker.id] as DeadlineStickerValue)
          : undefined
        const stage = Task.getGTDStage(t)

        if (
          stage === 'done' ||
          !val?.current?.deadline ||
          !DeadlineCtl.isSpoiled(val.current, {task: t})
        ) {
          return
        }
      } else {
        return
      }
    }

    const task = taskItemFromHub(box, t)
    tasks.push(task)
  })

  return tasks
}
